/// <amd-module name="Test/Analytics/Common/Utils/TestAnalyticsURLUtils" />
import { ITestReportContext } from "Test/Analytics/Common/Types";
import { TestResultsContextType } from "Test/common-util/Contracts/Test";
import { getTFSPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureEnabled, isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { routeUrl } from "VSS/Platform/Location";

export function getTestAnalyticsPageUrl(pageContext: IVssPageContext, reportContext: ITestReportContext): string {
    const newTestAnalyticsRoute = "ms.vss-test-analytics-web.new-test-analytics-route";
    const tfsProjectData = getTFSPageData(pageContext);
    let route = "";

    const routeValues: { [key: string]: string } = {};
    routeValues["definitionId"] = reportContext.definitionId.toString();
    if (reportContext.contextType === TestResultsContextType.Build) {
        route = newTestAnalyticsRoute;
        routeValues["contextType"] = "build";
    } else {
        routeValues["contextType"] = "release";
        route = newTestAnalyticsRoute;
    }
    routeValues["project"] = tfsProjectData && tfsProjectData.project ? tfsProjectData.project.name : "";

    return routeUrl(pageContext, route, routeValues);
}
